import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';

import { SidebarService } from '../../modules/sidebar/sidebar.service';

@Component({
  selector: 'via-topbar',
  standalone: true,
  imports: [CommonModule, DividerModule, InputTextModule, DropdownModule],
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class OTopbarComponent {
  constructor(
    public titleService: Title,
    public sidebarService: SidebarService
  ) {}
}
